import React from 'react'
import { CircularProgress } from '@mui/material'

export default ({ message = 'Loading...' }) => (
  <div className="loadingWholePage">
    <div className="loadingWholePageIndicatorMessage">
      <CircularProgress className="loading__indicator" size={50} status="loading" left={0} top={0} />
    </div>
    <div className="loadingWholePageMessage">
      <h2>{message}</h2>
    </div>
  </div>
)
